import React from 'react'
import { bool, node } from 'prop-types'
import ResponsiveLayout from '../responsive-layout/ResponsiveLayout'

const targetBlank = { target: '_blank', rel: 'noopener noreferrer' }

const AdLink = ({ children, isBlank, ...rest }) => {
  const target = isBlank ? targetBlank : null
  return <ResponsiveLayout
    renderLarge={() => <a {...target} {...rest}>{children}</a>}
    renderMedium={() => <a {...rest}>{children}</a>}
  />
}

AdLink.propTypes = {
  children: node,
  isBlank: bool
}

export default AdLink